/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * The helper to form BreadCrumb data from type
 *
 * @author Anton Panasenko
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.15.0
 * @since 1.2.0
 */

import { Dispatch } from 'redux';

import { CLIENT_ID, ROUTE_INQUIRY_ID, ROUTE_ORDER_ID, SUBSCRIBER_ID } from '../../../routes/constants/routesConstants';
import { stringFormat } from '../../../utils/stringFormat';
import { ICommonTranslationPages } from '../../internationalization/types/common/pages';
import { guardComponentType } from '../../role/reducer/guardReducer';
import { EBreadCrumbType, mapBreadCrumbTypeToData } from '../breadCrumbsTypes';

export interface IFormBreadCrumbDataProps {
    breadCrumbs: EBreadCrumbType[];
    dispatch: Dispatch;
    features: guardComponentType;
    matchedClientId?: string;
    matchedSubscriberId?: string;
    matchedOrderId?: string;
    matchedInquiryId?: string;
    pagesTranslation: ICommonTranslationPages;
}

export const formBreadCrumbData = (
    { breadCrumbs, dispatch, features, matchedClientId, matchedSubscriberId, matchedOrderId, matchedInquiryId,
        pagesTranslation }:
        IFormBreadCrumbDataProps) => {
    const mapBreadcrumbs = mapBreadCrumbTypeToData(dispatch, features, pagesTranslation);
    return breadCrumbs.map(breadCrumb => {
        const { url, isUrlExternal, title, onClick } = mapBreadcrumbs[breadCrumb];
        let urlFormat = url || '';
        if (url && isUrlExternal) {
            urlFormat = stringFormat(url, matchedClientId || matchedSubscriberId || matchedOrderId);
        } else {
            if (matchedClientId) {
                urlFormat = urlFormat.replace(CLIENT_ID, matchedClientId);
            }
            if (matchedSubscriberId) {
                urlFormat = urlFormat.replace(SUBSCRIBER_ID, matchedSubscriberId);
                urlFormat = urlFormat.replace(CLIENT_ID, matchedSubscriberId);
            }
            if (matchedOrderId) {
                urlFormat = urlFormat.replace(ROUTE_ORDER_ID, matchedOrderId);
            }
            if (matchedInquiryId) {
                urlFormat = urlFormat.replace(ROUTE_INQUIRY_ID, matchedInquiryId);
            }
        }
        return { url: urlFormat, isUrlExternal, title: pagesTranslation[title], onClick: onClick };
    });
};
